
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/science-figures",
      function () {
        return require("private-next-pages/science-figures/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/science-figures"])
      });
    }
  